import { render, staticRenderFns } from "./StatusDot.vue?vue&type=template&id=461e0ac4&"
import script from "./StatusDot.vue?vue&type=script&lang=js&"
export * from "./StatusDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports